import styled from 'styled-components/macro';
import {useEffect, useRef, useState} from "react";
import useDragToResize from "../utils/drag_to_resize";
import {useDimensions} from "../utils/dimensions";

const ResizableImage = styled(({className, post, alt}) => {
    const ref = useRef(null);
    const link = post?.link;
    const compressedMedia = post?.media.resized_resolutions[0] || false;

    const widthRef = useRef(null);
    const [width, setWidth] = useState(null);

    useEffect(() => {
        // Function to update width
        const updateWidth = () => {
            if (widthRef.current) {
                // Access the clientWidth property of the DOM element
                const newWidth = widthRef.current.clientWidth;
                setWidth(newWidth > 620 ? 620 : newWidth);
            }
        };

        // Initial width calculation
        updateWidth();

        // Event listener for window resize
        window.addEventListener('resize', updateWidth);

        // Cleanup: remove the event listener when the component unmounts
        return () => {
            window.removeEventListener('resize', updateWidth);
        };
    }, []);

    const dimensions = useDimensions(width, compressedMedia?.width || 0, compressedMedia?.height || 0);
    useDragToResize(ref);

    return (
        <div ref={widthRef} className={className}>
            {compressedMedia ?
                <div style={{
                    position: 'relative',
                    maxWidth: '100%',
                    height: dimensions[1] == 0 ? 'initial' : dimensions[1],
                    width: dimensions[0] == 0 ? 'initial' : dimensions[0]
                }}>
                    <img src={link} alt={""} ref={ref} style={{
                        position: 'absolute',
                        maxWidth: '100%',
                        height: dimensions[1] == 0 ? 'initial' : dimensions[1],
                        width: dimensions[0] == 0 ? 'initial' : dimensions[0]
                    }}/>
                </div>
                :
                <img src={link} alt={""} style={{
                    maxWidth: '100%',
                }}/>
            }
        </div>
    );
})`
  img {
    border-radius: 8px;
  }
  @media only screen and (min-width: 781px) {
    img {
      z-index: 2;
    }
  }`;

export default ResizableImage;
